var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 453.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d6d8e5;opacity:0.4;}.cls-2{fill:#b1b4c4;}.cls-3{fill:#616e84;}.cls-4{fill:#757b89;}.cls-5{fill:#20232d;}.cls-6{fill:#f2f5f9;}.cls-7{fill:#2b303f;}.cls-8{fill:#fff;}.cls-19,.cls-8{opacity:0.1;}.cls-9{fill:#b9cc00;}.cls-10{fill:#443d31;}.cls-11{fill:#c6e800;}.cls-12{fill:#ff6161;}.cls-13{fill:#e4e7ef;}.cls-14{fill:#edf1f9;}.cls-15{fill:#6675ff;}.cls-16{fill:#dadce5;}.cls-17{fill:#84a6f4;}.cls-18{fill:#db4949;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Map_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.79,449,7.13,377c-10.56-6.1-9.24-16.75,3-23.79L311.22,179.35c12.2-7,30.64-7.8,41.2-1.71l124.66,72c10.56,6.09,9.23,16.74-3,23.78L173,447.26C160.79,454.3,142.35,455.07,131.79,449Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.58,439.49l-124.66-72c-10.56-6.09-9.23-16.74,3-23.78L327,169.88c12.2-7,30.64-7.81,41.2-1.71l124.66,72c10.56,6.1,9.24,16.75-3,23.79L188.78,437.79C176.58,444.83,158.14,445.59,147.58,439.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "15.79 357.04 15.79 345.56 29.25 350.64 15.79 357.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "500 250.08 500 239.04 489.29 245.94 500 250.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.58,429.78l-124.66-72c-10.56-6.1-9.23-16.75,3-23.79L327,160.16c12.2-7,30.64-7.8,41.2-1.71l124.66,72c10.56,6.09,9.24,16.74-3,23.78L188.78,428.07C176.58,435.11,158.14,435.88,147.58,429.78Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 36.82,
    cy: 370.54,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-180.35 68.06) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 42.82,
    cy: 374.01,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-181.28 71.52) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 48.82,
    cy: 377.47,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-182.2 74.99) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 54.82,
    cy: 380.94,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-183.13 78.45) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 106.34,
    cy: 410.68,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-191.1 108.2) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 112.34,
    cy: 414.15,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-192.03 111.66) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 118.34,
    cy: 417.61,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-192.96 115.13) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 124.34,
    cy: 421.08,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-193.89 118.59) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.82,403.09l-16.48-9.52A4.51,4.51,0,0,1,70.45,390h0c0-1.39.84-2,1.89-1.43l16.48,9.52a4.51,4.51,0,0,1,1.89,3.61h0C90.71,403.05,89.87,403.69,88.82,403.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M462.27,277.41l-15.33,8.85c-1,.56-1.76,0-1.76-1.33h0a4.21,4.21,0,0,1,1.76-3.36l15.33-8.85c1-.56,1.75,0,1.75,1.33h0A4.21,4.21,0,0,1,462.27,277.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M438.79,291l-15.33,8.85c-1,.56-1.76,0-1.76-1.33h0a4.2,4.2,0,0,1,1.76-3.35l15.33-8.85c1-.56,1.75,0,1.75,1.33h0A4.19,4.19,0,0,1,438.79,291Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147.58,428,22.92,356c-10.56-6.09-9.23-16.74,3-23.78L327,158.4c12.2-7,30.64-7.81,41.2-1.71l124.66,72c10.56,6.1,9.24,16.75-3,23.79L188.78,426.31C176.58,433.35,158.14,434.11,147.58,428Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M473.49,234.53l-48.67-28.1-.12.07c-5.75,3.32-15.07,3.32-20.82,0s-5.75-8.7,0-12l.12-.07-48.67-28.1c-7.39-4.27-19.38-4.27-26.77,0L35.27,335.64c-7.39,4.27-7.39,11.19,0,15.45l118.15,68.22c7.4,4.27,19.38,4.27,26.77,0L473.49,250C480.88,245.72,480.88,238.8,473.49,234.53Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 417.09,
    cy: 199.33,
    rx: 5.59,
    ry: 3.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M415.44,200.29a1,1,0,0,1,0-1.91,3.64,3.64,0,0,1,3.31,0,1,1,0,0,1,0,1.91A3.64,3.64,0,0,1,415.44,200.29Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "277.5 349.62 173.56 410.06 131.41 385.73 235.36 325.29 277.5 349.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "383.81 200.97 204.51 305.47 155.42 278.59 334.71 174.09 383.81 200.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M206.1,264.1h-4.88v17.16a1.21,1.21,0,0,0,.71,1,3.81,3.81,0,0,0,3.45,0,1.2,1.2,0,0,0,.72-1h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 203.78,
    cy: 251.57,
    r: 12.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M236,246.94h-4.88v17.15a1.2,1.2,0,0,0,.72,1,3.81,3.81,0,0,0,3.45,0,1.21,1.21,0,0,0,.71-1h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 233.68,
    cy: 234.41,
    r: 12.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M298.23,214.27h-4.88v17.16a1.2,1.2,0,0,0,.72,1,3.81,3.81,0,0,0,3.45,0,1.21,1.21,0,0,0,.71-1h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 295.91,
    cy: 201.74,
    r: 12.79
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "390.75 220.89 117.87 378.44 107.48 372.44 380.36 214.89 390.75 220.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "411.29 275.84 367.99 250.84 367.99 146.84 411.29 171.84 411.29 275.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "411.29 171.84 367.99 146.84 411.29 121.84 454.59 146.84 411.29 171.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "403.5 193.34 375.79 177.34 375.79 163.34 403.5 179.34 403.5 193.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "454.59 250.84 411.29 275.85 411.29 171.85 454.59 146.85 454.59 250.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "429.48 187.35 419.08 193.35 419.08 179.35 429.48 173.35 429.48 187.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "446.8 177.35 436.4 183.35 436.4 169.35 446.8 163.35 446.8 177.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "429.48 208.35 419.08 214.35 419.08 200.35 429.48 194.35 429.48 208.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "446.8 198.35 436.4 204.35 436.4 190.35 446.8 184.35 446.8 198.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "429.48 229.35 419.08 235.35 419.08 221.35 429.48 215.35 429.48 229.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "446.8 219.35 436.4 225.35 436.4 211.35 446.8 205.35 446.8 219.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "429.48 251.35 419.08 257.35 419.08 243.35 429.48 237.35 429.48 251.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "446.8 241.35 436.4 247.35 436.4 233.35 446.8 227.35 446.8 241.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "403.5 214.34 375.79 198.34 375.79 184.34 403.5 200.34 403.5 214.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "403.5 235.34 375.79 219.34 375.79 205.34 403.5 221.34 403.5 235.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "403.5 257.34 375.79 241.34 375.79 227.34 403.5 243.34 403.5 257.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "411.29 160.85 386.31 146.43 386.31 141.96 411.29 156.39 411.29 160.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "411.29 160.85 436.28 146.43 436.28 141.96 411.29 156.39 411.29 160.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "152.49 335.55 109.19 310.55 109.19 146.56 152.49 171.56 152.49 335.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "152.49 171.56 109.19 146.56 152.49 121.56 195.79 146.56 152.49 171.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "144.69 193.06 116.98 177.06 116.98 163.06 144.69 179.06 144.69 193.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "195.79 310.56 152.49 335.56 152.49 171.56 195.79 146.56 195.79 310.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "170.67 187.06 160.28 193.06 160.28 179.06 170.67 173.06 170.67 187.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "187.99 177.06 177.6 183.06 177.6 169.06 187.99 163.06 187.99 177.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "170.67 208.06 160.28 214.06 160.28 200.06 170.67 194.06 170.67 208.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "187.99 198.06 177.6 204.06 177.6 190.06 187.99 184.06 187.99 198.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "170.67 229.06 160.28 235.06 160.28 221.06 170.67 215.06 170.67 229.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "187.99 219.06 177.6 225.06 177.6 211.06 187.99 205.06 187.99 219.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "170.67 251.06 160.28 257.06 160.28 243.06 170.67 237.06 170.67 251.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "187.99 241.06 177.6 247.06 177.6 233.06 187.99 227.06 187.99 241.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "170.67 274.55 160.28 280.55 160.28 266.56 170.67 260.56 170.67 274.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "187.99 264.55 177.6 270.55 177.6 256.56 187.99 250.56 187.99 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "170.67 298.57 160.28 304.57 160.28 290.57 170.67 284.57 170.67 298.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "187.99 288.57 177.6 294.57 177.6 280.57 187.99 274.57 187.99 288.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "144.69 214.06 116.98 198.06 116.98 184.06 144.69 200.06 144.69 214.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "144.69 235.06 116.98 219.06 116.98 205.06 144.69 221.06 144.69 235.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "144.69 257.06 116.98 241.06 116.98 227.06 144.69 243.06 144.69 257.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "144.69 280.55 116.98 264.55 116.98 250.56 144.69 266.56 144.69 280.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "144.69 304.57 116.98 288.57 116.98 274.57 144.69 290.57 144.69 304.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "152.49 160.57 127.5 146.15 127.5 141.68 152.49 156.11 152.49 160.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "152.49 160.57 177.48 146.15 177.48 141.68 152.49 156.11 152.49 160.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "152.49 335.55 109.19 310.55 109.19 146.56 152.49 171.56 152.49 335.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "152.49 171.56 109.19 146.56 152.49 121.56 195.79 146.56 152.49 171.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "144.7 193.06 116.98 177.06 116.98 163.06 144.7 179.06 144.7 193.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "195.79 310.56 152.49 335.56 152.49 171.56 195.79 146.56 195.79 310.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "170.68 187.06 160.28 193.06 160.28 179.06 170.68 173.06 170.68 187.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "188 177.06 177.6 183.06 177.6 169.06 188 163.06 188 177.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "170.68 208.06 160.28 214.06 160.28 200.06 170.68 194.06 170.68 208.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "188 198.06 177.6 204.06 177.6 190.06 188 184.06 188 198.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "170.68 229.06 160.28 235.06 160.28 221.06 170.68 215.06 170.68 229.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "188 219.06 177.6 225.06 177.6 211.06 188 205.06 188 219.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "170.68 251.06 160.28 257.06 160.28 243.06 170.68 237.06 170.68 251.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "188 241.06 177.6 247.06 177.6 233.06 188 227.06 188 241.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "170.68 274.55 160.28 280.55 160.28 266.56 170.68 260.56 170.68 274.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "188 264.55 177.6 270.55 177.6 256.56 188 250.56 188 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "170.68 298.57 160.28 304.57 160.28 290.57 170.68 284.57 170.68 298.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "188 288.57 177.6 294.57 177.6 280.57 188 274.57 188 288.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "144.7 214.06 116.98 198.06 116.98 184.06 144.7 200.06 144.7 214.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "144.7 235.06 116.98 219.06 116.98 205.06 144.7 221.06 144.7 235.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "144.7 257.06 116.98 241.06 116.98 227.06 144.7 243.06 144.7 257.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "144.7 280.55 116.98 264.55 116.98 250.56 144.7 266.56 144.7 280.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "144.7 304.57 116.98 288.57 116.98 274.57 144.7 290.57 144.7 304.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "152.49 160.57 127.5 146.15 127.5 141.68 152.49 156.11 152.49 160.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "152.49 160.57 177.48 146.15 177.48 141.68 152.49 156.11 152.49 160.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "347.21 311.34 303.91 286.34 303.91 122.34 347.21 147.34 347.21 311.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "347.21 147.34 303.9 122.34 347.2 97.34 390.51 122.34 347.21 147.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "339.41 168.84 311.7 152.84 311.7 138.84 339.41 154.84 339.41 168.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "390.51 286.35 347.2 311.35 347.2 147.35 390.51 122.35 390.51 286.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "365.39 162.85 355 168.85 355 154.85 365.39 148.85 365.39 162.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "382.71 152.85 372.32 158.85 372.32 144.85 382.71 138.85 382.71 152.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "365.39 183.85 355 189.85 355 175.85 365.39 169.85 365.39 183.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "382.71 173.85 372.32 179.85 372.32 165.85 382.71 159.85 382.71 173.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "365.39 204.85 355 210.85 355 196.85 365.39 190.85 365.39 204.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "382.71 194.85 372.32 200.85 372.32 186.85 382.71 180.85 382.71 194.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "365.39 226.85 355 232.85 355 218.85 365.39 212.85 365.39 226.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "382.71 216.85 372.32 222.85 372.32 208.85 382.71 202.85 382.71 216.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "365.39 250.34 355 256.34 355 242.34 365.39 236.34 365.39 250.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "382.71 240.34 372.32 246.34 372.32 232.34 382.71 226.34 382.71 240.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "365.39 274.36 355 280.36 355 266.36 365.39 260.36 365.39 274.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "382.71 264.36 372.32 270.36 372.32 256.36 382.71 250.35 382.71 264.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "339.41 189.84 311.7 173.84 311.7 159.84 339.41 175.84 339.41 189.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "339.41 210.84 311.7 194.84 311.7 180.84 339.41 196.84 339.41 210.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "339.41 232.84 311.7 216.84 311.7 202.84 339.41 218.84 339.41 232.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "339.41 256.34 311.7 240.34 311.7 226.34 339.41 242.34 339.41 256.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "339.41 280.36 311.7 264.36 311.7 250.35 339.41 266.36 339.41 280.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "347.21 136.36 322.22 121.93 322.22 117.47 347.21 131.89 347.21 136.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "347.21 136.36 372.2 121.93 372.2 117.47 347.21 131.89 347.21 136.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "96.2 367.56 52.9 342.56 52.9 238.56 96.2 263.56 96.2 367.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "96.2 263.56 52.9 238.56 96.19 213.56 139.5 238.56 96.2 263.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "88.4 285.06 60.69 269.06 60.69 255.06 88.4 271.06 88.4 285.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "139.5 342.56 96.2 367.56 96.2 263.57 139.5 238.57 139.5 342.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "114.38 279.07 103.99 285.07 103.99 271.07 114.38 265.07 114.38 279.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "131.7 269.07 121.31 275.07 121.31 261.07 131.7 255.07 131.7 269.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "114.38 300.07 103.99 306.07 103.99 292.07 114.38 286.07 114.38 300.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "131.7 290.07 121.31 296.07 121.31 282.07 131.7 276.07 131.7 290.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "114.38 321.07 103.99 327.07 103.99 313.07 114.38 307.07 114.38 321.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "131.7 311.07 121.31 317.07 121.31 303.07 131.7 297.07 131.7 311.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "114.38 343.06 103.99 349.06 103.99 335.06 114.38 329.06 114.38 343.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "131.7 333.06 121.31 339.06 121.31 325.06 131.7 319.06 131.7 333.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "88.4 306.06 60.69 290.06 60.69 276.06 88.4 292.06 88.4 306.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "88.4 327.06 60.69 311.06 60.69 297.06 88.4 313.06 88.4 327.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "88.4 349.06 60.69 333.06 60.69 319.06 88.4 335.06 88.4 349.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "96.2 252.57 71.21 238.15 71.21 233.68 96.2 248.11 96.2 252.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "96.2 252.57 121.19 238.15 121.19 233.68 96.2 248.11 96.2 252.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "285.3 345.77 242 320.77 242 216.77 285.3 241.77 285.3 345.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "285.3 241.77 241.99 216.77 285.29 191.77 328.6 216.77 285.3 241.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "277.5 263.27 249.79 247.27 249.79 233.27 277.5 249.27 277.5 263.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "328.6 320.77 285.3 345.77 285.3 241.78 328.6 216.78 328.6 320.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "303.48 257.28 293.09 263.28 293.09 249.28 303.48 243.28 303.48 257.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "320.8 247.28 310.41 253.28 310.41 239.28 320.8 233.28 320.8 247.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "303.48 278.28 293.09 284.28 293.09 270.28 303.48 264.28 303.48 278.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "320.8 268.28 310.41 274.28 310.41 260.28 320.8 254.28 320.8 268.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "303.48 299.27 293.09 305.27 293.09 291.27 303.48 285.27 303.48 299.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "320.8 289.27 310.41 295.27 310.41 281.27 320.8 275.27 320.8 289.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "303.48 321.27 293.09 327.27 293.09 313.27 303.48 307.27 303.48 321.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "320.8 311.27 310.41 317.27 310.41 303.27 320.8 297.27 320.8 311.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "277.5 284.27 249.79 268.27 249.79 254.27 277.5 270.27 277.5 284.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "277.5 305.27 249.79 289.27 249.79 275.27 277.5 291.27 277.5 305.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "277.5 327.27 249.79 311.27 249.79 297.27 277.5 313.27 277.5 327.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "285.3 230.78 260.31 216.36 260.31 211.89 285.3 226.32 285.3 230.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "285.3 230.78 310.29 216.36 310.29 211.89 285.3 226.32 285.3 230.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M236.68,337.16H231.8v17.16a1.22,1.22,0,0,0,.72,1,3.81,3.81,0,0,0,3.45,0,1.23,1.23,0,0,0,.71-1h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 234.36,
    cy: 324.63,
    r: 12.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M207.08,354.28H202.2v17.16a1.2,1.2,0,0,0,.72,1,3.81,3.81,0,0,0,3.45,0,1.21,1.21,0,0,0,.71-1h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 204.76,
    cy: 341.75,
    r: 12.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M175.41,372.59h-4.88v17.15a1.22,1.22,0,0,0,.71,1,3.83,3.83,0,0,0,3.46,0,1.22,1.22,0,0,0,.71-1h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 173.09,
    cy: 360.06,
    r: 12.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M353.56,3.63c-6.78-3.91-13-4.55-17.68-2.45h0l0,0a12.52,12.52,0,0,0-2.08,1.18L324.3,7.73s1.81,1.24,3.86,2.59A27.7,27.7,0,0,0,326.87,19a42.7,42.7,0,0,0,1,9l-2.75.21c0,.28,4.35,23.21,4.85,24.13s8.64,10.71,8.85,10.63a22.09,22.09,0,0,0,1.34-2.24c3.29,7.33,6.51,14,9,18.87l-8.3,3.82,3,10.19,10.73-6.13h0a.91.91,0,0,0,.17-.09c3.76-2.88,16.55-13.29,23.23-26.3a24.53,24.53,0,0,0,2.33-11.23C380.25,32.86,368.28,12.13,353.56,3.63Zm0,46.82c-7.64-4.41-13.86-15.18-13.86-24,0-7.37,4.34-11.07,10.21-9.53l-1.16.52c.78.92,13.56,23.34,14.13,25.77a18.48,18.48,0,0,0,3,5.6C363.63,52.68,359,53.57,353.56,50.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M342.85,9.75c-14.71-8.5-26.68-1.58-26.68,15.41a45.58,45.58,0,0,0,2.33,13.93C325.17,59.8,338,85,341.73,92.21a3.13,3.13,0,0,0,1.12,1.25,1,1,0,0,0,1.13.05c3.76-2.88,16.56-13.29,23.23-26.3A24.53,24.53,0,0,0,369.54,56C369.54,39,357.57,18.25,342.85,9.75Zm0,46.83c-7.64-4.42-13.86-15.19-13.86-24s6.22-12.41,13.86-8,13.87,15.18,13.87,24S350.5,61,342.85,56.58Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 347.21,
    cy: 116.1,
    rx: 13.79,
    ry: 7.96
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMobile);
export default __webpack_public_path__ + "static/media/map_mobile.8df9acb1810942ccdbb4ec0a796a80db.svg";
export { ForwardRef as ReactComponent };